/**
 * Preisabo for lbbw-am.de
 *
 * @author Florian Gutwald
 * Converted to Plain JS for Rollup
 */
export default class Preisabo {
  /**
   * Preisabo constructor
   *
   * @param {HTMLElement} element
   * @param {Object} options
   */
  constructor(element, options = {}) {
    this.element = element;
    this.options = Object.assign({}, options);

    this.init();
  }

  /**
   * Init method
   */
  init() {
    const fondsListContainer = document.getElementById('fondslist');
    if (!fondsListContainer) return;

    // Alle Checkbox-Container finden
    this.fondsList = Array.from(fondsListContainer.querySelectorAll('.form-input-checkbox'));

    this.setDataActive();
    this.initSelectAllFonds();

    // Event Delegation für den Typ-Filter (Ersatz für $(document).on('change', '#fonds_type', ...))
    document.addEventListener('change', (event) => {
      if (event.target && event.target.id === 'fonds_type') {
        this.handleFondsTypeSelection(event.target.value);
      }
    });
  }

  /**
   * handleFondsTypeSelection
   *
   * @param {string} value
   */
  handleFondsTypeSelection(value) {
    switch (value) {
      case 'all':
        this.showAllFonds();
        break;
      case 'min_true':
        this.showFondsListMitMindestanlage();
        break;
      case 'min_false':
        this.showFondsListOhneMindestanlage();
        break;
      case 'partner':
        this.showPartnerfonds();
        break;
      default:
        this.showAllFonds();
        break;
    }
  }

  /**
   * Show all fonds
   */
  showAllFonds() {
    this.filterFondsList(false, false, true);
  }

  /**
   * Show fonds mit Mindestanlage
   */
  showFondsListMitMindestanlage() {
    this.filterFondsList(true, false, false);
  }

  /**
   * Show fonds ohne Mindestanlage
   */
  showFondsListOhneMindestanlage() {
    this.filterFondsList(false, false, false);
  }

  /**
   * Show Partnerfonds
   */
  showPartnerfonds() {
    this.filterFondsList(false, true, false);
  }

  /**
   * @param {boolean} filterMindestanlage
   * @param {boolean} filterPartner
   * @param {boolean} all
   */
  filterFondsList(filterMindestanlage, filterPartner, all) {
    this.fondsList.forEach((el) => {
      if (!all) {
        // Datensätze aus data-Attributen lesen (JS konvertiert diese automatisch in entsprechende Typen)
        const mindestanlage = el.dataset.mindestanlage === 'true' || el.dataset.mindestanlage === true;
        const partner = el.dataset.partner === 'true' || el.dataset.partner === true;

        this._hideItem(el);
        if (mindestanlage === filterMindestanlage && partner === filterPartner) {
          this._showItem(el);
        }
      } else {
        this._showItem(el);
      }
    });

    this.initSelectAllFonds();
  }

  /**
   * Show item
   * @private
   */
  _showItem(element) {
    element.style.display = ''; // Zurück auf Standard (meist block oder flex)
    const checkbox = element.querySelector('input[type="checkbox"]');
    if (checkbox) {
      checkbox.setAttribute('data-active', 'true');
    }
  }

  /**
   * Hide item
   * @private
   */
  _hideItem(element) {
    element.style.display = 'none';
    const checkbox = element.querySelector('input[type="checkbox"]');
    if (checkbox) {
      checkbox.setAttribute('data-active', 'false');
      checkbox.checked = false;
    }
  }

  /**
   * Set data active to all checkboxes
   */
  setDataActive() {
    this.fondsList.forEach((item) => {
      const checkbox = item.querySelector('input[type="checkbox"]');
      if (checkbox) {
        checkbox.setAttribute('data-active', 'true');
      }
    });
  }

  /**
   * Init select all fonds checkbox
   */
  initSelectAllFonds() {
    const selectAllFonds = document.getElementById('newsletter-checkbox-1');
    if (!selectAllFonds) return;

    // Nur aktive (sichtbare) Checkboxen holen
    const activeCheckboxes = this.fondsList
      .map(item => item.querySelector('input[type="checkbox"][data-active="true"]'))
      .filter(checkbox => checkbox !== null);

    // Event Listener für "Alle auswählen"
    // Wir entfernen alte Listener nicht explizit, da wir das Element neu abgreifen,
    // aber sauberer ist es, den Listener nur einmal zu setzen.
    selectAllFonds.onchange = (e) => {
      const isChecked = e.target.checked;
      activeCheckboxes.forEach(cb => {
        cb.checked = isChecked;
      });
    };

    // Wenn eine einzelne Checkbox geändert wird, "Alle auswählen" deaktivieren
    activeCheckboxes.forEach(cb => {
      cb.onchange = () => {
        selectAllFonds.checked = false;
      };
    });
  }
}
